import React from "react";
import { useNavigate } from "react-router-dom";

import { Register } from "@examspark/common-app";

const RegisterRoute = () => {
  const navigate = useNavigate();

  return (
    <Register
      onRegister={() => navigate("/")}
      onBackToLogin={() => navigate("/login")}
    />
  );
};

export default RegisterRoute;
